import { css } from '@emotion/react';
import { Typography, Stack } from '@mui/material';
import { Box } from '@mui/system';
import { Image } from '@scorenco/components';

const style = {
  root: () => css`
    position: absolute;
    top: -5rem;
    left: 0;
    right: 0;
    height: calc(100vh - 0.5rem);
    background-image: url('/images/ad-scorenco/background.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;

    @keyframes floating {
      0% {
        transform: translate(0, 0px);
      }
      50% {
        transform: translate(0, 15px);
      }
      100% {
        transform: translate(0, -0px);
      }
    }
  `,
};

export const TournamentAdScorenco = () => {
  return (
    <Stack gap={4} css={style.root}>
      <Box sx={{ background: 'white', py: 2, px: 4, borderRadius: '0.5rem' }}>
        <Image
          src="/images/ad-scorenco/logo-scorenco-horizontal.svg"
          style={{ height: '6rem' }}
        />
      </Box>
      <Typography variant="h1" textAlign="center">
        Classements, calendriers,
        <br />
        résultats & matchs en direct
      </Typography>
      <Stack
        gap={8}
        direction="row"
        sx={{
          background: '#17DB84',
          px: 8,
          py: 2,
          animation: 'floating 5s infinite ease-in-out',
        }}
        alignItems="center"
      >
        <Box>
          <Stack gap={2} alignItems="center">
            <Typography variant="h2" textAlign="center">
              Suivez le tournoi sur <br />
              l'application gratuite Score'n'co
            </Typography>
            <Stack direction="row" gap={2} justifyContent="center">
              <Image
                style={{ height: '4rem' }}
                src="/images/ad-scorenco/appstore.png"
              />
              <Image
                style={{ height: '4rem' }}
                src="/images/ad-scorenco/playstore.png"
              />
            </Stack>
          </Stack>
        </Box>

        <Box sx={{ height: '20rem', borderRadius: '1rem', display: 'flex' }}>
          <Box sx={{ background: 'white' }}>
            <Image
              src="/images/ad-scorenco/tournament_qrcode.png"
              style={{ height: '20rem', borderRadius: '1rem' }}
            />
          </Box>
        </Box>
      </Stack>
    </Stack>
  );
};
